import { TableService } from './table-service';
import { AddressBook } from '../../../models/address-book';
import { AddressBooksQuery } from '../../../models/address-books-query';
import { Observable, of } from 'rxjs';
import { EntityEnum } from '../../../enum/entity.enum';
import { Sort } from '@angular/material/sort';
import {
    selectAddressBooksTableBusy, selectAddressBooksTableCount,
    selectAddressBooksTablePage, selectAddressBooksTableQuery,
    selectAddressBooksTableSelection
} from '../../../store/address-books-table/address-books-table.state';
import {
    addressBooksTableChangePage, addressBooksTableMasterToggle,
    addressBooksTableSort,
    addressBooksTableToggle
} from '../../../store/address-books-table/address-books-table.actions';
import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Injectable({ providedIn: 'root' })
export class AddressBookTableService extends TableService<AddressBook, AddressBooksQuery> {

    protected getBusyObservable(): Observable<boolean> {
        return this.store.select(selectAddressBooksTableBusy);
    }

    protected getColumnSelectionObservable(): Observable<string[]> {
        return of([ 'select', 'ADDRESS_BOOK_NAME', 'ADDRESS_BOOK_DESCRIPTION', 'ADDRESS_BOOK_VISIBILITY', 'actions' ]);
    }

    protected getCurrentPageEntriesObservable(): Observable<AddressBook[]> {
        return this.store.select(selectAddressBooksTablePage);
    }

    protected getEntity(): EntityEnum {
        return EntityEnum.ADDRESS_BOOK;
    }

    protected getSelectionObservable(): Observable<string[]> {
        return this.store.select(selectAddressBooksTableSelection);
    }

    protected getTableQueryObservable(): Observable<AddressBooksQuery> {
        return this.store.select(selectAddressBooksTableQuery);
    }

    protected getTotalCountObservable(): Observable<number> {
        return this.store.select(selectAddressBooksTableCount);
    }

    pageChange(page: PageEvent): void {
        this.store.dispatch(addressBooksTableChangePage({ pageNumber: page.pageIndex + 1, itemsPerPage: page.pageSize }));
    }

    sortChange(sort: Sort): void {
        this.store.dispatch(addressBooksTableSort({ id: sort.active, descending: sort.direction === 'desc' }));
    }

    toggle(id: string): void {
        this.store.dispatch(addressBooksTableToggle({ id }));
    }

    toggleAll(): void {
        this.store.dispatch(addressBooksTableMasterToggle());
    }

}
